module.exports = __webpack_public_path__ + "img/cabreuva.f3aec9a0.png";